import { useId, useState } from 'react';
import StandingsTable from './StandingsTable.js';

// Shared standings block (title + League/Conference toggle + table(s)) used
// by both the current-season homepage and the seasons archive page, so the
// two stay visually identical without duplicating this markup.
const StandingsSection = ({ teams, conferences }) => {
  const idPrefix = useId();
  const [showOverallStandings, setShowOverallStandings] = useState(true);

  if (!teams || teams.length === 0) return null;

  // The season doc's own `conferences` list is the authoritative signal for
  // whether this season actually had a real east/west split. Team-level
  // `conference` fields are not trustworthy on their own — they can be
  // stale/leaky (e.g. copied from a team's current-season assignment onto
  // an old season's snapshot) — so this never falls back to inferring from
  // team data; missing/non-array `conferences` just means no conferences.
  const hasConferences = Array.isArray(conferences) && conferences.length > 0;

  return (
    <div id="standings" className="homepage-section">
      <p className="mini-title">Standings</p>
      {hasConferences && (
        <div className="homepage-standings-toggle">
          <input type="radio" className="btn-check" name={`${idPrefix}-standingsRadio`} id={`${idPrefix}-btnLeague`} autoComplete="off" defaultChecked onChange={() => setShowOverallStandings(true)} />
          <label className="btn homepage-standings-btn" htmlFor={`${idPrefix}-btnLeague`}>League</label>
          <input type="radio" className="btn-check" name={`${idPrefix}-standingsRadio`} id={`${idPrefix}-btnConference`} autoComplete="off" onChange={() => setShowOverallStandings(false)} />
          <label className="btn homepage-standings-btn" htmlFor={`${idPrefix}-btnConference`}>Conference</label>
        </div>
      )}
      {showOverallStandings || !hasConferences
        ? <StandingsTable teams={teams} />
        : <>
            <p className="league-title-standard-secondary text-align-center">Western Conference</p>
            <StandingsTable teams={teams.filter(t => t.conference === 'west')} />
            <p className="league-title-standard-secondary text-align-center">Eastern Conference</p>
            <StandingsTable teams={teams.filter(t => t.conference === 'east')} />
          </>
      }
    </div>
  );
};

export default StandingsSection;
